import type { ComponentType, FC, PropsWithChildren } from "react";

import type { ButtonType } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";

import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { LockedWithHookCTA } from "app/components/widget/components/LockedWithHookCTA";
import type { IHookConfig } from "app/components/widget/types";
import { WidgetFooterButtonContainer, WidgetFooterContainer } from "app/components/React/WidgetContainer/styledComponents";

export interface IFooterButton {
    type: ButtonType;
    text: string;
    link: string;
    onClick?: VoidFunction;
    unlockHook?: IHookConfig;
}

interface IWidgetFooterProps {
    wrapperComponent?: ComponentType<PropsWithChildren>;
    buttonsConfig?: IFooterButton[];
}

export const WidgetFooter: FC<IWidgetFooterProps> = ({ buttonsConfig, wrapperComponent = WidgetFooterContainer }) => {
    const Wrapper = wrapperComponent;

    return (
        <Wrapper>
            {buttonsConfig?.map(({ link, text, type, onClick, unlockHook }) => (
                <WidgetFooterButtonContainer
                    key={text}
                    href={link}
                >
                    {unlockHook && !isAvailable(swSettings.components[unlockHook.component]) ? (
                        <LockedWithHookCTA
                            label={text}
                            unlockHook={unlockHook}
                        />
                    ) : (
                        <Button
                            className="widget-footer__button"
                            type={type}
                            label={text}
                            onClick={onClick}
                        />
                    )}
                </WidgetFooterButtonContainer>
            ))}
        </Wrapper>
    );
};
